import {
  FaFileInvoice,
  FaInstagram,
  FaLink,
  FaMoneyCheck
} from 'react-icons/fa'
import { PageContainer } from './styles'

interface IFinishedPage {
  getPdfBoleto: (financialMovimentPaymentId: number, barCode: string) => void
  previewContract: () => void
  createdFinancialMoviments: IFinancialMoviment[]
}
export const FinishedPage = ({
  getPdfBoleto,
  previewContract,
  createdFinancialMoviments
}: IFinishedPage): JSX.Element => {
  return (
    <PageContainer>
      <div>
        <h1>Obrigado!</h1>
        <p>Sua compra foi concluída!</p>
        <p>Ja estamos cuidando de tudo…</p>
        <p>Parabéns por se importar tanto!</p>
        <p>Você é fantástico!</p>
        <div>
          <button
            className="btn btn-primary"
            style={{ margin: '15px', padding: '8px 10px' }}
            onClick={() => previewContract()}
          >
            <FaFileInvoice style={{ marginRight: '5px' }} />
            Imprimir Contrato
          </button>
          <button
            className="btn btn-primary"
            style={{ margin: '15px', padding: '8px 10px' }}
            onClick={() => {
              if (createdFinancialMoviments?.length) {
                getPdfBoleto(
                  createdFinancialMoviments?.[0].financialMovimentsPayments[0]
                    .id,
                  createdFinancialMoviments?.[0].financialMovimentsPayments[0]
                    .bar_code
                )
              }
            }}
          >
            <FaMoneyCheck style={{ marginRight: '5px' }} />
            Imprimir Boleto
          </button>
        </div>
        <div style={{ marginTop: '100px' }}>
          <a
            href="https://www.merenderia.com.br"
            target="_blank"
            rel="noreferrer"
          >
            <FaLink style={{ marginRight: '5px' }} />
            Site
          </a>
          <a
            href="https://instagram.com/merenderia?igshid=YmMyMTA2M2Y="
            target="_blank"
            rel="noreferrer"
          >
            <FaInstagram style={{ marginRight: '5px' }} />
            Instagram
          </a>
        </div>
      </div>
    </PageContainer>
  )
}
